/**
 * Payment Service
 * Handles payment-related API calls
 */

import { api } from '../utils/apiClient'
import { devLog, devError } from '../utils/devLog'

/**
 * Creates a payment order
 */
export const createPaymentOrder = async (paymentData) => {
  try {
    devLog('Creating payment order', paymentData)
    const response = await api.post('/api/payment/create-order', paymentData)
    devLog('Payment order response', response)
    return {
      success: true,
      data: response,
    }
  } catch (error) {
    devError('Create order error', error)
    return {
      success: false,
      error: error.message || 'Failed to create payment order',
    }
  }
}

/**
 * Verifies payment after Razorpay callback
 */
export const verifyPayment = async (verificationData) => {
  try {
    devLog('Verifying payment', { orderId: verificationData.orderId, razorpayPaymentId: verificationData.razorpayPaymentId })
    const response = await api.post('/api/payment/verify', verificationData)
    devLog('Verification response', response)
    return {
      success: true,
      data: response,
    }
  } catch (error) {
    devError('Verify payment error', error)
    return {
      success: false,
      error: error.message || 'Payment verification failed',
    }
  }
}
